const ENDPOINT_ACS_ASSET = 'https://api.unrekt.net/api/v2/acryptos-asset.json';

export async function getTotalTVL(): Promise<number> {
  const data = await (await fetch(ENDPOINT_ACS_ASSET)).json();
  const total_tvl = data.acryptos ? parseFloat(data.acryptos.total_tvl.all) : 0;
  return total_tvl;
}
